if (!customElements.get('rs-bundle')) {
  const RS_COLORS = {
    black: '#0a0a0a', czarny: '#0a0a0a', czarna: '#0a0a0a',
    white: '#ffffff', 'biały': '#ffffff', bialy: '#ffffff', 'biała': '#ffffff',
    grey: '#9a9a9a', gray: '#9a9a9a', szary: '#9a9a9a',
    pink: '#f4b6c2', 'różowy': '#f4b6c2', red: '#c4302b', blue: '#3b5bdb',
    navy: '#1f2a44', beige: '#e8dcc8', brown: '#6b4f3a', green: '#3b6d11'
  };

  customElements.define('rs-bundle', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const raw = this.querySelector('.rs-bundle__data');
      if (!raw) return;
      this.data = JSON.parse(raw.textContent);
      this.byId = {};
      this.data.items.forEach((it) => (this.byId[it.id] = it));
      this.need = parseInt(this.dataset.picks, 10) || 1;
      this.kind = this.dataset.kind || '';
      this.mode = 'set';
      this.busy = false;
      this.picked = [];
      this.rows = Array.from(this.querySelectorAll('.rs-bundle__opt-row'));
      this.cards = Array.from(this.querySelectorAll('.rs-bundle__card'));
      this.countEl = this.querySelector('.rs-bundle__count');
      this.hintEl = this.querySelector('.rs-bundle__hint');
      this.panelsEl = this.querySelector('.rs-bundle__panels');

      this.rows.forEach((r) => {
        r.addEventListener('click', (e) => {
          if (e.target.closest('.rs-bundle__body')) return;
          this.setMode(r.dataset.mode);
        });
        r.addEventListener('keydown', (e) => {
          if (e.target !== r) return;
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.setMode(r.dataset.mode); }
        });
      });
      this.cards.forEach((c) => c.addEventListener('click', () => this.toggle(c.dataset.pid)));

      this.onAtc = (e) => {
        if (this.mode !== 'set') return;
        const btn = e.target.closest && e.target.closest('[ref="addToCartButton"]');
        if (!btn) return;
        if (btn !== this.mainButton() && !btn.closest('sticky-add-to-cart')) return;
        const main = this.mainButton();
        if (!main || main.disabled) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        if (this.busy) return;
        if (this.complete()) this.buy();
        else this.nudge();
      };
      document.addEventListener('click', this.onAtc, true);

      this.onHint = (e) => {
        const a = e.target.closest && e.target.closest('.rs-rcpt__hint');
        if (!a) return;
        const t = a.textContent.toLowerCase();
        const match =
          (this.kind === 'long' && t.includes('drugi long')) ||
          (this.kind === 'hoodie' && t.includes('do bluzy')) ||
          (this.kind === 'tee' && t.includes('2 koszulki'));
        if (!match) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        const drawer = document.querySelector('theme-drawer#cart-drawer');
        if (drawer && typeof drawer.close === 'function') drawer.close();
        this.setMode('set');
        setTimeout(() => this.scrollIntoView({ behavior: 'smooth', block: 'center' }), 350);
      };
      document.addEventListener('click', this.onHint, true);

      const form = this.mainForm();
      if (form && 'MutationObserver' in window) {
        this.mo = new MutationObserver(() => {
          clearTimeout(this.moT);
          this.moT = setTimeout(() => this.label(), 30);
        });
        this.mo.observe(form, { childList: true, subtree: true, characterData: true });
      }
      this.label();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onAtc, true);
      document.removeEventListener('click', this.onHint, true);
      if (this.mo) this.mo.disconnect();
    }

    mainForm() { return document.querySelector('form[data-type="add-to-cart-form"]'); }
    mainButton() {
      const f = this.mainForm();
      return f ? f.querySelector('[ref="addToCartButton"]') : null;
    }
    isSize(n) { return /rozmiar|size/i.test(n); }
    isColor(n) { return /kolor|color|colour/i.test(n); }
    values(prod, k) { return Array.from(new Set(prod.variants.map((v) => v.options[k]))); }
    fits(prod, sel) {
      return prod.variants.some((v) => v.available && v.options.every((o, j) => sel[j] === null || sel[j] === o));
    }
    resolve(item) {
      if (item.sel.some((s) => s === null)) return null;
      return item.prod.variants.find((v) => v.available && v.options.every((o, j) => o === item.sel[j])) || null;
    }
    complete() {
      return this.picked.length >= this.need && this.picked.every((it) => this.resolve(it));
    }

    mainSize() {
      if (!/[?&]variant=/.test(window.location.search)) return null;
      const cur = this.data.current;
      const inp = this.mainForm() && this.mainForm().querySelector('input[name="id"]');
      const v = inp && cur.variants.find((x) => String(x.id) === String(inp.value));
      const k = cur.options.findIndex((n) => this.isSize(n));
      return v && k > -1 ? v.options[k] : null;
    }

    colorOf(prod, k, val) {
      const sw = prod.swatches && prod.swatches[k] && prod.swatches[k][val];
      if (sw) return sw;
      return RS_COLORS[String(val).trim().toLowerCase()] || null;
    }

    setMode(mode) {
      if (mode === this.mode) return;
      this.mode = mode;
      this.rows.forEach((r) => {
        const on = r.dataset.mode === mode;
        r.classList.toggle('is-on', on);
        r.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      this.hintEl.hidden = true;
      this.label();
    }

    toggle(id) {
      const i = this.picked.findIndex((it) => it.id === id);
      if (i > -1) {
        this.drop(i);
      } else {
        if (this.picked.length >= this.need) this.drop(0);
        this.add(id);
      }
      this.sync();
    }

    add(id) {
      const prod = this.byId[id];
      if (!prod) return;
      const first = prod.variants.find((v) => v.available) || prod.variants[0];
      const size = this.mainSize();
      const sel = prod.options.map((name, k) => {
        const vals = this.values(prod, k);
        if (vals.length === 1) return vals[0];
        if (this.isSize(name)) return size && vals.includes(size) ? size : null;
        return first ? first.options[k] : null;
      });
      const item = { id, prod, sel };
      if (!this.fits(prod, sel)) {
        prod.options.forEach((n, k) => { if (this.isSize(n)) sel[k] = null; });
      }
      this.build(item);
      this.picked.push(item);
    }

    drop(i) {
      const it = this.picked[i];
      if (it && it.el) it.el.remove();
      this.picked.splice(i, 1);
    }

    sync() {
      const ids = this.picked.map((it) => it.id);
      this.cards.forEach((c) => c.setAttribute('aria-pressed', ids.includes(c.dataset.pid) ? 'true' : 'false'));
      if (this.countEl) this.countEl.textContent = this.picked.length + '/' + this.need;
      if (this.complete()) this.hintEl.hidden = true;
      this.label();
    }

    build(item) {
      const el = document.createElement('div');
      el.className = 'rs-bundle__panel';
      const img = document.createElement('img');
      img.className = 'rs-bundle__pimg';
      img.alt = item.prod.name;
      img.width = 104;
      img.height = 104;
      el.appendChild(img);
      const body = document.createElement('div');
      body.className = 'rs-bundle__pbody';
      const head = document.createElement('div');
      head.className = 'rs-bundle__phead';
      const nm = document.createElement('span');
      nm.textContent = item.prod.name;
      const x = document.createElement('button');
      x.type = 'button';
      x.className = 'rs-bundle__x';
      x.setAttribute('aria-label', 'Usuń ' + item.prod.name);
      x.textContent = '×';
      x.addEventListener('click', () => this.toggle(item.id));
      head.append(nm, x);
      const opts = document.createElement('div');
      body.append(head, opts);
      el.appendChild(body);
      item.el = el;
      item.img = img;
      item.opts = opts;
      this.panelsEl.appendChild(el);
      this.renderOpts(item);
      this.photo(item);
    }

    renderOpts(item) {
      const { prod, sel } = item;
      item.opts.innerHTML = '';
      prod.options.forEach((name, k) => {
        const vals = this.values(prod, k);
        if (vals.length < 2) return;
        const size = this.isSize(name);
        const color = this.isColor(name);
        const lab = document.createElement('p');
        lab.className = 'rs-bundle__glabel' + (size ? ' rs-bundle__glabel--size' : '');
        lab.textContent = name + (color && sel[k] ? ': ' + sel[k] : '');
        const wrap = document.createElement('div');
        wrap.className = 'rs-bundle__opts' + (size ? ' rs-bundle__opts--size' : '');
        vals.forEach((val) => {
          const b = document.createElement('button');
          b.type = 'button';
          const hex = color ? this.colorOf(prod, k, val) : null;
          if (hex) {
            b.className = 'rs-bundle__sw';
            b.style.background = hex;
            b.setAttribute('aria-label', val);
            b.title = val;
          } else {
            b.className = 'rs-bundle__pill';
            b.textContent = val;
          }
          b.setAttribute('aria-pressed', sel[k] === val ? 'true' : 'false');
          const trial = sel.slice();
          trial[k] = val;
          if (!this.fits(prod, trial)) b.disabled = true;
          b.addEventListener('click', () => this.choose(item, k, val));
          wrap.appendChild(b);
        });
        item.opts.append(lab, wrap);
      });
    }

    choose(item, k, val) {
      const { prod, sel } = item;
      sel[k] = val;
      prod.options.forEach((n, j) => {
        if (j === k || sel[j] === null) return;
        if (!this.fits(prod, sel)) sel[j] = null;
      });
      item.el.classList.remove('is-missing');
      this.renderOpts(item);
      this.photo(item);
      this.sync();
    }

    photo(item) {
      const { prod, sel } = item;
      const v = prod.variants.find((x) => x.image && x.options.every((o, j) => sel[j] === null || sel[j] === o));
      const src = (v && v.image) || prod.image || '';
      if (src && item.img.getAttribute('src') !== src) item.img.src = src;
    }

    label() {
      const btn = this.mainButton();
      if (!btn) return;
      const node = this.textNode(btn);
      if (!node) return;
      if (!btn.dataset.rsOrig) btn.dataset.rsOrig = node.nodeValue.trim();
      let want = btn.dataset.rsOrig;
      if (this.mode === 'set' && !btn.disabled) {
        if (this.busy) want = 'Dodaję…';
        else if (this.picked.length < this.need) want = this.dataset.need;
        else if (!this.complete()) want = this.dataset.size;
        else want = this.dataset.ready;
      }
      if (node.nodeValue.trim() !== want) node.nodeValue = want;
    }

    textNode(btn) {
      const direct = Array.from(btn.childNodes).find((n) => n.nodeType === 3 && n.nodeValue.trim());
      if (direct) return direct;
      const w = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT, {
        acceptNode: (n) => (n.nodeValue.trim() && !n.parentElement.closest('svg, .svg-wrapper, .add-to-cart__added') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP)
      });
      return w.nextNode();
    }

    nudge() {
      this.hintEl.textContent = this.picked.length < this.need ? this.dataset.need : this.dataset.size;
      this.hintEl.hidden = false;
      this.picked.forEach((it) => it.el.classList.toggle('is-missing', !this.resolve(it)));
      this.scrollIntoView({ behavior: 'smooth', block: 'center' });
      this.classList.remove('is-flash');
      void this.offsetWidth;
      this.classList.add('is-flash');
    }

    reset() {
      while (this.picked.length) this.drop(0);
      this.sync();
    }

    async buy() {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const inp = this.mainForm() && this.mainForm().querySelector('input[name="id"]');
      const mainId = inp ? parseInt(inp.value, 10) : null;
      if (!mainId) return;
      this.busy = true;
      this.hintEl.hidden = true;
      this.label();
      let deferred = null;
      try {
        let hasMain = false;
        try {
          const before = await fetch(root + 'cart.js').then((r) => r.json());
          hasMain = before.items.some((i) => String(i.product_id) === String(this.data.current.id));
        } catch (e) {}
        const ids = (hasMain ? [] : [mainId]).concat(this.picked.map((it) => this.resolve(it).id));
        const drawer = document.querySelector('theme-drawer#cart-drawer');
        const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
          .map((el) => el.dataset.sectionId)
          .filter(Boolean);
        let Ev = null;
        if (drawer) {
          try { Ev = (await import('@shopify/events')).CartLinesUpdateEvent; } catch (e) { Ev = null; }
        }
        if (Ev) {
          deferred = Ev.createPromise();
          this.dispatchEvent(new Ev({
            action: 'add',
            context: 'product',
            lines: ids.map((id) => ({ merchandiseId: String(id), quantity: 1 })),
            promise: deferred.promise
          }));
        }
        const res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: ids.map((id) => ({ id: id, quantity: 1 })),
            sections: sectionIds.join(',')
          })
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error('add');
        if (!Ev) {
          window.location.href = root + 'cart';
          return;
        }
        const cart = await fetch(root + 'cart.js').then((r) => r.json());
        deferred.resolve({
          cart: Ev.createCartFromAjaxResponse(cart),
          detail: {
            items: cart.items,
            source: 'rs-bundle',
            itemCount: ids.length,
            productId: String(this.data.current.id),
            sections: data.sections,
            didError: false
          }
        });
        this.busy = false;
        this.reset();
      } catch (e) {
        if (deferred) deferred.reject(e);
        this.busy = false;
        this.label();
        this.hintEl.textContent = 'Nie udało się dodać. Spróbuj jeszcze raz.';
        this.hintEl.hidden = false;
      }
    }
  });
}